module.exports = __webpack_public_path__ + "img/roblox.ac65017f.png";